import { Component } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

import TimetoastPropTypes from '../../../../constants/timetoast_prop_types'
import { defaultColorScheme } from '@helpers/color_scheme_helpers.js'

import EditableColorPalette from './editable_color_palette'

export default class ColorSchemeEditor extends Component {
  handleChange = colorScheme => {
    const { onChange } = this.props
    onChange(colorScheme)
  }

  render() {
    const { colorScheme } = this.props
    return <EditableColorPalette colorScheme={colorScheme} onChange={this.handleChange} />
  }
}
ColorSchemeEditor.propTypes = {
  colorScheme: TimetoastPropTypes.colorScheme.isRequired,
  onChange: PropTypes.func.isRequired,
}
ColorSchemeEditor.defaultProps = {
  colorScheme: defaultColorScheme(),
  onChange: noop,
}
